import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  previewImage?: string;
}
export function Accordion({
  title,
  children,
  isOpen = false,
  previewImage
}: AccordionProps) {
  const [open, setOpen] = useState(isOpen);
  return <div className="border border-gray-200 bg-white rounded-lg mb-3 overflow-hidden shadow-sm" data-id="element-159">
      {previewImage && <div className="relative w-full h-32 md:h-40 overflow-hidden" data-id="element-160">
          <img src={previewImage} alt="" aria-hidden="true" className="w-full h-full object-cover object-top" data-id="element-161" />
          {/* Gradient fade into the card */}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/20 to-white" data-id="element-162" />
        </div>}
      <button className="w-full px-4 py-4 flex justify-between items-center text-left focus:outline-none" onClick={() => setOpen(!open)} data-id="element-163">
        <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-164">
          {title}
        </span>
        {open ? <ChevronUp className="w-5 h-5 text-green-700 flex-shrink-0" data-id="element-165" /> : <ChevronDown className="w-5 h-5 text-green-700 flex-shrink-0" data-id="element-166" />}
      </button>
      {open && <div className="px-4 pb-4 text-gray-600 text-sm md:text-base whitespace-pre-line border-t border-gray-100 pt-3" data-id="element-167">
          {children}
        </div>}
    </div>;
}